import Vue from 'vue'
import App from './App.vue'

// Tailwind
import './tailwind/tailwind.css'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')